import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAppSelector, useAppDispatch } from '../hooks';
import { Link } from 'react-router-dom';
import { createDeviceZigbee } from '../actions/CreateDeviceZigbee';
import { saveDevice } from '../actions/SaveDevice';
import { fetchZigbeeNodeEndpointGroups } from '../actions/FetchZigbeeNodeEndpointGroups';
import { clusterName, clusterNameOrHex } from '../types/Zigbee/Cluster';
import { ConfigZigbeeEndpointAttributes } from '../components/ConfigZigbeeEndpointAttributes';
import { ZigbeeNodeEndpointGroups } from '../components/ZigbeeNodeEndpointGroups';
import { Group } from '../components/Group';
export const ConfigZigbeeEndpoint = (props) => {
    const dispatch = useAppDispatch();
    const zigbee_nodes = useAppSelector(state => state.definitions.zigbee_nodes);
    const devices = useAppSelector(state => state.definitions.devices);
    const node = zigbee_nodes[props.node];
    if (node == undefined) {
        return null;
    }
    const endpoint = node.endpoints[props.endpoint];
    if (endpoint == undefined) {
        return null;
    }
    const endpointPredicate = (d) => {
        return d.protocol.name == 'zigbee'
            && d.protocol.zigbee_node_id == node.id
            && d.protocol.endpoint_id == endpoint.endpoint;
    };
    const endpointDevices = Object.values(devices).filter(endpointPredicate);
    let device_id = null;
    let device_title = '';
    const device = endpointDevices[0];
    if (device != undefined) {
        device_id = device.id;
        device_title = device.title;
    }
    const [title, setTitle] = React.useState(device_title);
    const onChange = event => {
        setTitle(event.target.value);
    };
    const onSubmit = event => {
        event.preventDefault();
        if (device_id) {
            dispatch(saveDevice(device_id, title));
        }
        else {
            dispatch(createDeviceZigbee(props.node, props.endpoint, title));
        }
    };
    const clusterTooltip = (c) => {
        const clusterStr = clusterName(c);
        if (clusterStr != undefined)
            return clusterStr + ' id=0x' + c.toString(16).padStart(4, '0');
        else
            return undefined;
    };
    const input_clusters = endpoint.input_clusters.map(c => _jsxs("span", { title: clusterTooltip(c), children: [clusterNameOrHex(c), " "] }, c));
    const output_clusters = endpoint.output_clusters.map(c => _jsxs("span", { title: clusterTooltip(c), children: [clusterNameOrHex(c), " "] }, c));
    const deviceElem = _jsx(Link, { to: '/device/' + device_id, children: _jsxs("span", { style: { color: 'green' }, children: [" ", device_title] }) });
    const profile = endpoint.profile_name ? endpoint.profile_name : endpoint.profile;
    const zigbee_device = endpoint.device_name ? endpoint.device_name : '-';
    return (_jsxs(Group, { title: 'Endpoint: ' + props.endpoint, children: [_jsxs("div", { children: [profile, " ", zigbee_device] }), _jsxs("div", { children: ["input=", input_clusters] }), _jsxs("div", { children: ["output=", output_clusters] }), _jsxs("div", { children: [device_id, " ", deviceElem] }), _jsx("form", { onSubmit: onSubmit, children: _jsx("input", { type: "text", size: 30, value: title, onChange: onChange }) }), _jsx(ConfigZigbeeEndpointAttributes, { node: props.node, endpoint: props.endpoint }), _jsx("hr", {}), _jsx(ZigbeeNodeEndpointGroups, { groups: endpoint.groups, onFetchEndpointGroups: () => dispatch(fetchZigbeeNodeEndpointGroups(props.node, props.endpoint)) })] }));
};
